const escapeForScript = (value) => {
  const json = JSON.stringify(value)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
  const scriptClose = "</scr" + "ipt";
  return json.replace(new RegExp(scriptClose, "gi"), "<\\/script");
};

const viewerBootstrap = function productDataViewerBootstrap(rawProducts) {
  const dataset = (rawProducts || []).map(function mapProduct(product) {
    return {
      product,
      search: JSON.stringify(product).toLowerCase(),
    };
  });

  const container = document.getElementById("productContainer");
  const totalCountEl = document.getElementById("totalCount");
  const visibleCountEl = document.getElementById("visibleCount");
  const searchBox = document.getElementById("searchBox");

  if (!container || !totalCountEl || !visibleCountEl || !searchBox) {
    return;
  }

  totalCountEl.textContent = String(dataset.length);

  const formatPrimitive = (value) => {
    if (value === null || value === undefined) return "-";
    if (typeof value === "boolean") return value ? "Yes" : "No";
    if (Array.isArray(value)) {
      if (value.length === 0) return "-";
      return value
        .map((item) => {
          if (item === null || item === undefined) return "";
          if (typeof item === "object") {
            try {
              return JSON.stringify(item);
            } catch (error) {
              return String(item);
            }
          }
          return String(item);
        })
        .filter(Boolean)
        .join(" • ");
    }
    return String(value);
  };

  const formatKey = (key) => {
    if (!key) return "";
    return key
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .replace(/[-_]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/^./, (c) => c.toUpperCase());
  };

  const getItemLabel = (parentKey, item, index) => {
    const base = parentKey ? formatKey(parentKey.replace(/s$/, "")) : "Item";
    if (item && typeof item === "object") {
      const fallbackKeysByParent = {
        racks: ["customId", "title", "serialNo", "rackType"],
        rack: ["customId", "title", "serialNo", "rackType"],
        pucks: ["serialNo", "title", "color", "puckType"],
        puck: ["serialNo", "title", "color", "puckType"],
        wells: ["title", "customId", "color", "gridNumbering", "boxType"],
        well: ["title", "customId", "color", "gridNumbering", "boxType"],
      };
      const parentKeyLower = (parentKey || "").toLowerCase();
      const candidates = fallbackKeysByParent[parentKeyLower] || [
        "customId",
        "title",
        "name",
        "serialNo",
        "description",
      ];
      const parts = [];
      candidates.forEach((key) => {
        if (item[key]) {
          parts.push(formatPrimitive(item[key]));
        }
      });
      if (parts.length) {
        return `${base || "Item"} ${index + 1} - ${parts.join(" | ")}`;
      }
    }
    return `${base || "Item"} ${index + 1}`;
  };

  const createEmptyNode = (text) => {
    const span = document.createElement("span");
    span.className = "empty";
    span.textContent = text;
    return span;
  };

  const isPlainObject = (value) => value && typeof value === "object" && !Array.isArray(value);

  const createInfoTableFromObject = (source, excludeKeys = []) => {
    if (!isPlainObject(source)) {
      return null;
    }

    const rows = Object.entries(source).filter(([key, value]) => {
      if (excludeKeys.includes(key)) return false;
      if (Array.isArray(value)) {
        const hasObjects = value.some((item) => isPlainObject(item));
        return !hasObjects;
      }
      return !isPlainObject(value);
    });

    if (!rows.length) {
      return null;
    }

    const table = document.createElement("table");
    table.className = "kv-table compact";
    rows.forEach(([key, value]) => {
      const row = document.createElement("tr");
      const th = document.createElement("th");
      th.textContent = formatKey(key);
      const td = document.createElement("td");
      td.textContent = formatPrimitive(value);
      row.appendChild(th);
      row.appendChild(td);
      table.appendChild(row);
    });

    return table;
  };

  const createSection = (title) => {
    const section = document.createElement("section");
    section.className = "detail-section";
    if (title) {
      const heading = document.createElement("h3");
      heading.textContent = title;
      section.appendChild(heading);
    }
    const body = document.createElement("div");
    body.className = "detail-section-body";
    section.appendChild(body);
    return { section, body };
  };

  const renderValue = (value, parentKey, depth = 0) => {
    if (value === null || value === undefined) {
      return createEmptyNode("-");
    }

    if (Array.isArray(value)) {
      if (value.length === 0) {
        return createEmptyNode("No entries");
      }

      const primitivesOnly = value.every((item) => item === null || typeof item !== "object");
      if (primitivesOnly) {
        const list = document.createElement("ul");
        list.className = "primitive-list";
        value.forEach((item) => {
          const li = document.createElement("li");
          li.textContent = formatPrimitive(item);
          list.appendChild(li);
        });
        return list;
      }

      const wrapper = document.createElement("div");
      wrapper.className = "array-container";
      value.forEach((item, index) => {
        const details = document.createElement("details");
        if (depth < 1 && value.length <= 5) {
          details.open = true;
        }
        const summary = document.createElement("summary");
        summary.textContent = getItemLabel(parentKey, item, index);
        details.appendChild(summary);
        details.appendChild(renderValue(item, parentKey && parentKey.replace(/s$/, ""), depth + 1));
        wrapper.appendChild(details);
      });
      return wrapper;
    }

    if (typeof value === "object") {
      const entries = Object.entries(value);
      if (entries.length === 0) {
        return createEmptyNode("No data");
      }

      const table = document.createElement("table");
      table.className = "kv-table";
      entries.forEach(([key, val]) => {
        const row = document.createElement("tr");
        const th = document.createElement("th");
        th.textContent = formatKey(key);
        const td = document.createElement("td");
        if (val && typeof val === "object") {
          td.appendChild(renderValue(val, key, depth + 1));
        } else {
          td.textContent = formatPrimitive(val);
        }
        row.appendChild(th);
        row.appendChild(td);
        table.appendChild(row);
      });
      return table;
    }

    const span = document.createElement("span");
    span.textContent = formatPrimitive(value);
    return span;
  };

  const overlay = document.getElementById("detailOverlay");
  const detailTitleEl = document.getElementById("detailTitle");
  const detailBodyEl = document.getElementById("detailBody");
  const detailCloseBtn = document.getElementById("detailClose");

  const createWellDetails = (wellKey, wellData, index) => {
    const details = document.createElement("details");
    details.className = "nested-block";
    if (index < 2) {
      details.open = true;
    }

    const summary = document.createElement("summary");
    const summaryParts = [formatKey(wellKey)];
    if (wellData.title) summaryParts.push(String(wellData.title));
    if (wellData.customId) summaryParts.push(`ID: ${wellData.customId}`);
    if (wellData.color) summaryParts.push(`Color: ${wellData.color}`);
    if (wellData.boxType) summaryParts.push(`Box: ${wellData.boxType}`);
    summary.textContent = summaryParts.filter(Boolean).join(" • ") || formatKey(wellKey);
    details.appendChild(summary);

    const nestedKeys = Object.entries(wellData)
      .filter(([, value]) => isPlainObject(value))
      .map(([key]) => key);

    const infoTable = createInfoTableFromObject(wellData, nestedKeys);
    if (infoTable) {
      details.appendChild(infoTable);
    }

    nestedKeys.forEach((key) => {
      const value = wellData[key];
      const quadrant = document.createElement("details");
      quadrant.className = "nested-block";
      const quadrantSummary = document.createElement("summary");
      quadrantSummary.textContent = formatKey(key);
      quadrant.appendChild(quadrantSummary);
      quadrant.appendChild(renderValue(value, key, 2));
      details.appendChild(quadrant);
    });

    return details;
  };

  const createPuckDetails = (puck, index) => {
    const details = document.createElement("details");
    details.className = "nested-block";
    if (index < 2) {
      details.open = true;
    }

    const summary = document.createElement("summary");
    const summaryParts = [`Puck ${index + 1}`];
    if (puck.serialNo) summaryParts.push(`#${puck.serialNo}`);
    if (puck.title) summaryParts.push(String(puck.title));
    if (puck.color) summaryParts.push(`Color: ${puck.color}`);
    summary.textContent = summaryParts.filter(Boolean).join(" • ");
    details.appendChild(summary);

    const wellEntries = Object.entries(puck).filter(
      ([key, value]) => key.toLowerCase().startsWith("well") && isPlainObject(value)
    );
    const wellKeys = wellEntries.map(([key]) => key);

    const infoTable = createInfoTableFromObject(puck, wellKeys);
    if (infoTable) {
      details.appendChild(infoTable);
    }

    if (wellEntries.length) {
      const wellsContainer = document.createElement("div");
      wellsContainer.className = "nested-collection";
      wellEntries.forEach(([wellKey, wellData], wellIndex) => {
        wellsContainer.appendChild(createWellDetails(wellKey, wellData, wellIndex));
      });
      details.appendChild(wellsContainer);
    } else {
      const empty = document.createElement("div");
      empty.className = "empty";
      empty.textContent = "No wells recorded.";
      details.appendChild(empty);
    }

    return details;
  };

  const createRackDetails = (rack, index) => {
    const details = document.createElement("details");
    details.className = "nested-block";
    if (index < 2) {
      details.open = true;
    }

    const summary = document.createElement("summary");
    const summaryParts = [`Rack ${index + 1}`];
    if (rack.customId) summaryParts.push(String(rack.customId));
    if (rack.serialNo) summaryParts.push(`#${rack.serialNo}`);
    if (rack.rackType) summaryParts.push(rack.rackType);
    summary.textContent = summaryParts.filter(Boolean).join(" • ");
    details.appendChild(summary);

    const infoTable = createInfoTableFromObject(rack, ["pucks"]);
    if (infoTable) {
      details.appendChild(infoTable);
    }

    if (Array.isArray(rack.pucks) && rack.pucks.length) {
      const pucksContainer = document.createElement("div");
      pucksContainer.className = "nested-collection";
      rack.pucks.forEach((puck, puckIndex) => {
        pucksContainer.appendChild(createPuckDetails(puck, puckIndex));
      });
      details.appendChild(pucksContainer);
    } else {
      const empty = document.createElement("div");
      empty.className = "empty";
      empty.textContent = "No pucks in this rack.";
      details.appendChild(empty);
    }

    return details;
  };

  const closeOverlay = () => {
    if (!overlay) {
      return;
    }
    overlay.classList.add("hidden");
    document.body.classList.remove("no-scroll");
    if (detailBodyEl) {
      detailBodyEl.innerHTML = "";
    }
  };

  const renderProductDetails = (product) => {
    const container = document.createElement("div");
    container.className = "detail-sections";

    const overview = createInfoTableFromObject(product, ["racks"]);
    if (overview) {
      const { section, body } = createSection("Product overview");
      body.appendChild(overview);
      container.appendChild(section);
    }

    if (Array.isArray(product.racks) && product.racks.length) {
      const { section, body } = createSection(`Racks (${product.racks.length})`);
      product.racks.forEach((rack, rackIndex) => {
        body.appendChild(createRackDetails(rack, rackIndex));
      });
      container.appendChild(section);
    }

    const knownKeys = new Set(["racks"]);
    Object.entries(product).forEach(([key, value]) => {
      if (knownKeys.has(key)) {
        return;
      }
      if (!value || (Array.isArray(value) && value.length === 0)) {
        return;
      }

      const { section, body } = createSection(formatKey(key));
      body.appendChild(renderValue(value, key, 0));
      container.appendChild(section);
    });

    return container;
  };

  const openOverlay = (product, index) => {
    if (!overlay || !detailTitleEl || !detailBodyEl) {
      return;
    }
    detailTitleEl.textContent =
      product.title || product.customId || `Product ${index + 1}`;
    detailBodyEl.innerHTML = "";
    detailBodyEl.appendChild(renderProductDetails(product));
    overlay.classList.remove("hidden");
    document.body.classList.add("no-scroll");
    detailBodyEl.scrollTop = 0;
  };

  if (detailCloseBtn) {
    detailCloseBtn.addEventListener("click", closeOverlay);
  }
  if (overlay) {
    overlay.addEventListener("click", (event) => {
      if (event.target === overlay) {
        closeOverlay();
      }
    });
  }
  window.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && overlay && !overlay.classList.contains("hidden")) {
      closeOverlay();
    }
  });

  const createProductCard = (product, index) => {
    const card = document.createElement("article");
    card.className = "product-card";

    const header = document.createElement("header");
    header.className = "card-header";

    const title = document.createElement("h2");
    title.textContent = product.title || product.customId || `Product ${index + 1}`;
    header.appendChild(title);

    const meta = document.createElement("div");
    meta.className = "meta";
    const badges = [];
    if (product.customId) badges.push(`ID: ${product.customId}`);
    if (product.capacity !== undefined && product.capacity !== null) badges.push(`Capacity: ${product.capacity}`);
    if (Array.isArray(product.racks)) badges.push(`Racks: ${product.racks.length}`);
    if (product.project) badges.push(`Project: ${product.project}`);
    badges.forEach((label) => {
      const span = document.createElement("span");
      span.textContent = label;
      meta.appendChild(span);
    });
    header.appendChild(meta);
    card.appendChild(header);

    const summaryBits = [];
    if (product.details) summaryBits.push(product.details);
    if (product.description) summaryBits.push(product.description);
    const summaryText = summaryBits
      .map((text) => String(text).trim())
      .filter(Boolean)
      .join(" • ");
    if (summaryText) {
      const summary = document.createElement("p");
      summary.className = "card-summary";
      summary.textContent = summaryText;
      card.appendChild(summary);
    }

    const actions = document.createElement("div");
    actions.className = "card-actions";
    const viewButton = document.createElement("button");
    viewButton.type = "button";
    viewButton.className = "view-button";
    viewButton.textContent = "View details";
    viewButton.addEventListener("click", () => openOverlay(product, index));
    actions.appendChild(viewButton);
    card.appendChild(actions);

    return card;
  };

  const renderProducts = (items) => {
    container.innerHTML = "";
    if (!items.length) {
      const emptyState = document.createElement("div");
      emptyState.className = "no-results";
      emptyState.textContent = "No products match your search.";
      container.appendChild(emptyState);
      return;
    }
    const fragment = document.createDocumentFragment();
    items.forEach(({ product }, index) => {
      fragment.appendChild(createProductCard(product, index));
    });
    container.appendChild(fragment);
  };

  const applyFilter = (term) => {
    const query = term.trim().toLowerCase();
    if (!query) {
      visibleCountEl.textContent = String(dataset.length);
      renderProducts(dataset);
      return;
    }
    const filtered = dataset.filter((entry) => entry.search.includes(query));
    visibleCountEl.textContent = String(filtered.length);
    renderProducts(filtered);
  };

  renderProducts(dataset);
  searchBox.addEventListener("input", function handleInput(event) {
    applyFilter(event.target.value);
  });
};

export const buildProductHtmlViewer = (products, generatedAt) => {
  const serializedProducts = escapeForScript(products);
  const generatedLabel = generatedAt || new Date().toLocaleString();
  const scriptContent = `(${viewerBootstrap.toString()})(${serializedProducts});`;
  const closingScriptTag = "</scr" + "ipt>";

  const htmlContent = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Product Data Viewer</title>
  <style>
    :root {
      color-scheme: light dark;
    }
    body {
      margin: 0;
      padding: 32px;
      background: #f1f5f9;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
      color: #0f172a;
    }
    .container {
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
    .page-header h1 {
      margin: 0;
      font-size: 2rem;
      color: #0c4a6e;
    }
    .page-header p {
      margin: 4px 0 0;
      color: #475569;
    }
    .toolbar {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      align-items: center;
    }
    .stats {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      color: #1e293b;
      font-weight: 500;
    }
    .stats span strong {
      color: #0c4a6e;
    }
    .search-box {
      flex: 1 1 280px;
      min-width: 250px;
      padding: 12px 16px;
      border: 2px solid #0c4a6e;
      border-radius: 8px;
      font-size: 16px;
      outline: none;
      transition: box-shadow 0.2s ease;
      background: white;
      color: inherit;
    }
    .search-box:focus {
      box-shadow: 0 0 0 3px rgba(14, 116, 144, 0.2);
    }
    .product-grid {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    .product-card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
      padding: 20px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      border: 1px solid rgba(148, 163, 184, 0.3);
      overflow: visible;
      max-width: 960px;
      width: 100%;
      margin: 0 auto;
    }
    .product-card h2 {
      margin: 0;
      font-size: 1.25rem;
      color: #0c4a6e;
    }
    .meta {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      color: #475569;
      font-size: 0.9rem;
    }
    .meta span {
      background: #e2e8f0;
      padding: 2px 8px;
      border-radius: 999px;
    }
    .card-summary {
      color: #475569;
      line-height: 1.5;
      margin: 0;
    }
    .card-summary strong {
      color: #0f172a;
    }
    .card-actions {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
    }
    .view-button {
      appearance: none;
      border: none;
      background: #0c4a6e;
      color: white;
      font-weight: 600;
      font-size: 0.95rem;
      padding: 10px 18px;
      border-radius: 999px;
      cursor: pointer;
      transition: background 0.2s ease;
    }
    .view-button:hover {
      background: #0369a1;
    }
    .detail-sections {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
    .detail-section {
      background: #f8fafc;
      border: 1px solid rgba(148, 163, 184, 0.35);
      border-radius: 12px;
      padding: 18px 20px;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    .detail-section h3 {
      margin: 0;
      font-size: 1.1rem;
      color: #0f172a;
    }
    .detail-section-body {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .nested-collection {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    table.kv-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 0.9rem;
      table-layout: fixed;
      word-break: break-word;
    }
    table.kv-table th {
      text-align: left;
      width: 180px;
      padding: 6px 8px;
      background: #f1f5f9;
      color: #0f172a;
      vertical-align: top;
      border-bottom: 1px solid #e2e8f0;
    }
    table.kv-table td {
      padding: 6px 8px;
      border-bottom: 1px solid #e2e8f0;
      color: #1e293b;
      word-break: break-word;
    }
    table.kv-table tr:last-child th,
    table.kv-table tr:last-child td {
      border-bottom: none;
    }
    table.kv-table.compact th {
      width: 120px;
    }
    .nested-block {
      border: 1px solid rgba(148, 163, 184, 0.4);
      border-radius: 8px;
      padding: 8px 12px;
      background: rgba(241, 245, 249, 0.6);
    }
    .nested-block summary {
      cursor: pointer;
      font-weight: 600;
      color: #0c4a6e;
      list-style: none;
      outline: none;
      white-space: normal;
      word-break: break-word;
    }
    .nested-block summary::-webkit-details-marker {
      display: none;
    }
    .nested-block summary::before {
      content: ">";
      display: inline-block;
      margin-right: 8px;
      transform: rotate(0deg);
      transition: transform 0.2s ease;
    }
    .nested-block[open] summary::before {
      transform: rotate(90deg);
    }
    .array-container {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-top: 8px;
    }
    .array-container details {
      border: 1px solid rgba(148, 163, 184, 0.3);
      border-radius: 6px;
      padding: 6px 10px;
      background: white;
      overflow: auto;
    }
    .array-container summary {
      font-weight: 600;
      color: #0369a1;
      cursor: pointer;
      white-space: normal;
      word-break: break-word;
    }
    ul.primitive-list {
      margin: 0;
      padding-left: 18px;
      color: #1e293b;
    }
    .empty {
      font-style: italic;
      color: #64748b;
    }
    .no-results {
      text-align: center;
      color: #475569;
      padding: 60px 20px;
      border: 2px dashed rgba(148, 163, 184, 0.4);
      border-radius: 12px;
      background: rgba(241, 245, 249, 0.5);
    }
    .detail-overlay {
      position: fixed;
      inset: 0;
      background: rgba(15, 23, 42, 0.65);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px 24px;
      z-index: 9999;
    }
    .detail-overlay.hidden {
      display: none;
    }
    .detail-dialog {
      background: white;
      border-radius: 18px;
      box-shadow: 0 25px 50px -12px rgba(30, 41, 59, 0.45);
      max-width: 1040px;
      width: 100%;
      max-height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .detail-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      padding: 24px 32px 12px;
    }
    .detail-header h2 {
      margin: 0;
      color: #0c4a6e;
      font-size: 1.5rem;
    }
    .detail-close {
      appearance: none;
      border: none;
      background: #1e293b;
      color: white;
      border-radius: 999px;
      padding: 8px 14px;
      cursor: pointer;
      font-weight: 600;
      transition: background 0.2s ease;
    }
    .detail-close:hover {
      background: #0f172a;
    }
    .detail-body {
      padding: 0 32px 32px;
      overflow-y: auto;
      max-height: 70vh;
    }
    body.no-scroll {
      overflow: hidden;
    }
    @media (max-width: 600px) {
      body {
        padding: 16px;
      }
      .product-card {
        padding: 16px;
      }
      .detail-dialog {
        border-radius: 12px;
      }
      .detail-header {
        padding: 16px 20px 8px;
      }
      .detail-body {
        padding: 0 20px 20px;
        max-height: 65vh;
      }
    }
  </style>
</head>
<body>
  <div class="container">
    <header class="page-header">
      <h1>Product Data Viewer</h1>
      <p>Generated ${generatedLabel}</p>
    </header>
    <div class="toolbar">
      <input id="searchBox" class="search-box" type="search" placeholder="Search products, racks, pucks or wells" />
      <div class="stats">
        <span><strong>Total products:</strong> <span id="totalCount">${products.length}</span></span>
        <span><strong>Showing:</strong> <span id="visibleCount">${products.length}</span></span>
      </div>
    </div>
    <section id="productContainer" class="product-grid"></section>
  </div>
  <div id="detailOverlay" class="detail-overlay hidden">
    <div class="detail-dialog" role="dialog" aria-modal="true">
      <header class="detail-header">
        <h2 id="detailTitle">Product Details</h2>
        <button id="detailClose" class="detail-close" type="button">Close</button>
      </header>
      <div id="detailBody" class="detail-body"></div>
    </div>
  </div>
  <script>
${scriptContent}
  ${closingScriptTag}
</body>
</html>`;

  return htmlContent;
};
